import {
    PARTNUMBERS_CREATE_EDIT_OPEN_MODAL,
    PARTNUMBERS_CREATE_REQUEST,
    PARTNUMBERS_CREATE_RESULT,
    PARTNUMBERS_UPDATE_REQUEST,
    PARTNUMBERS_UPDATE_RESULT,
    PARTNUMBERS_GET_REQUEST,
    PARTNUMBERS_GET_RESULT,
} from 'Redux/actionTypes';

export const partNumberCreateEditOpenModal = (data) => ({
    type: PARTNUMBERS_CREATE_EDIT_OPEN_MODAL,
    payload: data
})

export const partNumberCreateRequest = (data) => ({
    type: PARTNUMBERS_CREATE_REQUEST,
    payload: data
})

export const partNumberCreateResult = (result) => ({
    type: PARTNUMBERS_CREATE_RESULT,
    payload: result
})

export const partNumberUpdateRequest = (data) => ({
    type: PARTNUMBERS_UPDATE_REQUEST,
    payload: data
})

export const partNumberUpdateResult = (result) => ({
    type: PARTNUMBERS_UPDATE_RESULT,
    payload: result
})

export const partNumberGetRequest = (data) => ({
    type: PARTNUMBERS_GET_REQUEST,
    payload: data
})

export const partNumberGetResult = (result) => ({
    type: PARTNUMBERS_GET_RESULT,
    payload: result
})